import { render, staticRenderFns } from "./TheDisasterRecoveryPrivacyNotice.vue?vue&type=template&id=6231e059&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports